//Home page - auto play media grid videos on hover | then auto play on scroll view in mobile

document.addEventListener("DOMContentLoaded", function () {
    const videos = document.querySelectorAll(".autoplay-video");

    function isMobile() {
        return window.matchMedia("(max-width: 768px)").matches;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                const video = entry.target;
                if (isMobile()) {
                    if (entry.isIntersecting) {
                        video.play();
                    } else {
                        video.pause();
                        video.currentTime = 0; // Reset when out of view
                    }
                }
            });
        },
        { threshold: 0.8 } // Trigger when 80% of video is visible
    );

    videos.forEach((video) => {
        observer.observe(video);

        if (!isMobile()) {
            video.addEventListener("mouseenter", () => video.play());
            video.addEventListener("mouseleave", () => {
                video.pause();
                video.currentTime = 0; // Reset when hover ends
            });
        }
    });
});


// Product Gallery Load More (Desktop Only)
document.addEventListener("DOMContentLoaded", function () {
  const loadMoreBtn = document.getElementById("load-more-btn");
  let currentIndex = 4; // Already showing 4

  function isDesktop() {
    return window.innerWidth >= 1024; // Adjust breakpoint as needed
  }

  if (loadMoreBtn && isDesktop()) {
    loadMoreBtn.addEventListener("click", function () {
      const hiddenItems = document.querySelectorAll(".product-gallery__media.desktop-hidden");

      for (let i = 0; i < 4; i++) {
        if (hiddenItems[i]) {
          hiddenItems[i].classList.remove("desktop-hidden");
          currentIndex++;
        }
      }

      // Hide button if all items are visible
      if (currentIndex >= document.querySelectorAll(".product-gallery__media").length) {
        loadMoreBtn.style.display = "none";
      }
    });
  }
});

